import monitorBloc from "../../services/bloc";
import { Vue } from "vue-class-component";
import { Tab } from "@cems-eco/core/src/models";
import { first, isEmpty } from "lodash"; // use in template
import { Equipment } from "@/modules/maintenance/services/model";

export class BaseMonitorViewPage extends Vue {
  monitorBloc = monitorBloc;
  equipment: any = {};
  equipments: any = [];
  equipmentId: any;
  tabs: Tab;
  activeTabIndex: number = 0;

  map: any = {
    center: [],
    markerLatLng: [],
  };
  subscription: any = {
    alarm: null,
  }

  async fetchMap(equipment: any) {
    try {
      this.map = {
        center: [
          equipment.additional.latitude as number,
          equipment.additional.longitude as number,
        ],
      };
    } catch (e) {}
  }

  public get isLoaded(): boolean {
    return isEmpty(this.equipment);
  }

  setTabs() {
    this.tabs = new Tab();
    this.tabs.list = [
      {
        id: "alarm",
        name: "Alarm",
        icon: "fa fa-bell",
        active: true,
        component: "AlarmComponent",
      },
      {
        id: "system",
        name: "System",
        icon: "fa fa-info-circle",
        active: false,
        component: "SystemComponent",
        // props: {
        //     equipmentId: this.equipment.id,
        //     equipment: this.equipment
        // }
      },
      {
        id: "map",
        name: "Map",
        icon: "far fa-map",
        active: false,
        component: "MapComponent",
        // props: {
        //     equipmentId: this.equipment.id,
        //     equipment: this.equipment
        // }
      },
    ];
  }

  onTabChanged(index: number) {
    this.activeTabIndex = index;
  }
}
